import { RootState } from '../../../../utils/type';

export const selectVendorList = (state: RootState) => state.vendorList.data;
export const selectVendorListLoading = (state: RootState) => state.vendorList.loading;
export const selectVendorListError = (state: RootState) => state.vendorList.error;
